import { useMemo } from 'react';

import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { WEB_SHOP_REQUEST_DATA } from './constants';

export const useWebShopMaskOverlayRequest = (
  id: string | number
): DataRequest => {
  return useMemo<DataRequest>(() => {
    return {
      entity: Entities.webShopDefinition,
      data: WEB_SHOP_REQUEST_DATA,
      vars: {
        ids: [id],
      },
      completeDataResponse: true,
    };
  }, [id]);
};
